module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"label_ApplyWatermarkOnPreview":"Watermark su anteprima","label_OpenAccount":"Open Account","editSgpClientSettings":"Modifica Impostazioni","formSgpClientSettings":{"ApplyWatermarkOnPreview":"Watermark su anteprima","OpenAccount":"Open Account","DefaultLicenseId":"Licenza d\u0027uso predefinita"}}}')
  delete Component.options._Ctor
}
